module.exports = __webpack_public_path__ + "static/SectionThree-58ba0ae9f1445f113f92ff71b8f1de66.png";